import React, { useContext } from "react";
import PropTypes from "prop-types";
import { ThemeContext } from "helpers/contexts.js";
import { SIZE } from "constant";

import Text from "components/common/Text";
import styled from "styled-components";

ListItemText.propTypes = {
  onClick: PropTypes.func,
  isSelected: PropTypes.bool,
  primary: PropTypes.string.isRequired,
  primarySize: PropTypes.oneOf([
    SIZE.xs,
    SIZE.small,
    SIZE.medium,
    SIZE.large,
    SIZE.xl,
    SIZE.xxl,
    SIZE._3xl,
  ]),
  secondary: PropTypes.string,
  secondarySize: PropTypes.oneOf([
    SIZE.xs,
    SIZE.small,
    SIZE.medium,
    SIZE.large,
    SIZE.xl,
    SIZE.xxl,
    SIZE._3xl,
  ]),
  primaryBold: PropTypes.bool,
  secondaryIsFirst: PropTypes.bool,
  size: PropTypes.oneOf([
    SIZE.xs,
    SIZE.small,
    SIZE.medium,
    SIZE.large,
    SIZE.xl,
    SIZE.xxl,
    SIZE._3xl,
  ]),
};
ListItemText.defaultProps = {
  isSelected: false,
  primary: null,
  secondary: null,
  size: SIZE.medium,
  secondaryIsFirst: false,
  primaryBold: false,
};

function ListItemText(props) {
  const theme = useContext(ThemeContext);
  let primaryColor = theme.colors.gray.charcoal;
  let secondaryColor = theme.colors.gray.gray600;
  let onTextHover = null;

  if (props.onClick) {
    onTextHover = ["underline"];
  }

  if (props.isSelected) {
    primaryColor = theme.colors.p1;
  }

  function renderPrimaryText() {
    if (props.primary) {
      return (
        <PrimaryContainer
          withMarginTop={props.secondaryIsFirst}
          onClick={props.onClick}
          title={props.primary}
        >
          <Text
            size={props.primarySize ? props.primarySize : props.size}
            bold={props.primaryBold}
            color={primaryColor}
            ellipsis={true}
            onHover={onTextHover}
          >
            {props.primary}
          </Text>
        </PrimaryContainer>
      );
    }
    return ``;
  }

  function renderSecondaryText() {
    if (props.secondary) {
      return (
        <SecondaryContainer
          withMarginTop={!props.secondaryIsFirst}
          title={props.secondary}
        >
          <Text
            size={props.secondarySize ? props.secondarySize : props.size}
            color={secondaryColor}
            ellipsis={true}
          >
            {props.secondary}
          </Text>
        </SecondaryContainer>
      );
    }
    return ``;
  }

  return (
    <TextContainer>
      {props.secondaryIsFirst ? (
        <>
          {renderSecondaryText()}
          {renderPrimaryText()}
        </>
      ) : (
        <>
          {renderPrimaryText()}
          {renderSecondaryText()}
        </>
      )}
    </TextContainer>
  );
}

const SecondaryContainer = styled.div`
  ${(props) => (props.withMarginTop ? `margin-top: 3px;` : ``)}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const PrimaryContainer = styled.div`
  ${(props) => (props.withMarginTop ? `margin-top: 3px;` : ``)}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TextContainer = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: -webkit-fill-available;
`;

export default ListItemText;
